import React, { Component } from 'react';
import Accordian from '../Accordian';
import img1 from '../../img/how-courses-work/01-course-overview.jpg';
import img2 from '../../img/how-courses-work/02-video-class.jpg';
import img3 from '../../img/how-courses-work/03-quiz.jpg';
import img4 from '../../img/how-courses-work/04-booking-calendar.jpg';
import img5 from '../../img/how-courses-work/05-tutorial.png';
import img6 from '../../img/how-courses-work/06-messages.jpg';

const items = [
  {
    id: 1,
    title: 'Course Overview',
    description: 'This is the course structure. View your course progression, watch video classes and arrange your tutorials from here.',
    image: img1
  },
  {
    id: 2,
    title: 'Video classes',
    description: 'Learn BSL by watching the video classes – you can watch them as many times as you wish.',
    image: img2
  },
  {
    id: 3,
    title: 'Quizzes',
    description: 'Take fun, interactive quizzes to guide your learning and prepare well for your tutorials.',
    image: img3
  },
  {
    id: 4,
    title: 'Booking calendar',
    description: 'Use the calendar to book a tutorial with your tutor. Click on the day you wish to book and a list of your tutor’s availability will appear.',
    image: img4
  },
  {
    id: 5,
    title: 'Tutorials',
    // description: 'Gain valuable feedback and support from your tutor via one-to-one tutorials. Your tutor will call you via Skype at the date and time you have selected on the calendar. Your tutor will record these tutorial sessions and make it available on your course overview for you to watch as many times as you wish.',
    description: 'Gain valuable feedback and support from your tutor via one-to-one tutorials. Your tutor will call you via Skype at the date and time you have selected on the calendar. Your tutor will record these tutorial sessions and make it available to you to download and watch as many times as you wish',
    image: img5
  },
  {
    id: 6,
    title: 'Messages',
    description: 'Here, you can keep in touch with your tutor by sending them direct messages.',
    image: img6
  }
];

class HowItWorksAccordian extends Component {
  render () {
    return (
      <Accordian items={items} />
    );
  }
}

export default HowItWorksAccordian;



// WEBPACK FOOTER //
// ./src/components/HowItWorksAccordian/index.js